import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@material-ui/core";
import { authProvider } from "../../services/Security";
import { FormController } from "../shared/FormController";
import { $UserLogin } from "../../services/V2/keymaster";
import { useSecurity } from "./Security";
import { LoggedIn } from "../../App";
import { withToast } from "../shared/Toast";

const Login = ({ setShow, setIsLoggedIn, errorToast, successToast }) => {
    const [model, setModel] = useState<any>();
    const [code, setCode] = useState<any>();
    const [step, setStep] = useState<number>(0)
    const { login } = useSecurity();

    const handleCancel = () => {
        setShow(false)
    }

    const handleLogin = () => {
        authProvider.loginCredentials(model)
            .then(response => {
                successToast(response)
                setStep(1)
            })
            .catch(err => {
                errorToast(err.title)
            })
    }

    const sendCode = () => {
        authProvider.loginCode(model, code)
            .then(response => {
                setIsLoggedIn(LoggedIn.True)
                setShow(false)
            })
            .catch(err => {
                errorToast(err.Message)
            })
    }

    const handleSysAdminLogin = () => {
        login()
        setShow(false)
    }

    return (
        <Dialog
        open={true}
        onClose={handleCancel}
        aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Login</DialogTitle>
            <DialogContent>
                {step === 0 &&
                    <FormController
                        keys={$UserLogin.properties}
                        disabledKeys={[]}
                        extraKeys={null}
                        editMode={true}
                        model={model}
                        setModel={setModel}
                        canReadUserRoles={false}
                        canReadMeters={false}
                        canReadServiceAddresses={false}
                        districtId={null} />
                }
                {step === 1 &&
                    <TextField
                        onChange={e => setCode(e.target.value)}
                        margin="normal"
                        name={"code"}
                        label={"Check Email for code."}
                        type="text"
                        value={code ?? ""}
                        fullWidth
                    />
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>
                    Cancel
                </Button>
                <Button
                    color="primary"
                    onClick={() => step === 0 ? handleLogin() : sendCode()}
                >
                    Login
                </Button>
                <Button
                    hidden={step !== 0}
                    onClick={handleSysAdminLogin}
                    color="primary"
                >
                    SysAdmin Login
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default withToast(Login);